module.exports = {"511381001":"保宁街道","511381003":"沙溪街道","511381004":"七里街道","511381005":"江南街道","511381006":"河溪街道","511381103":"彭城镇","511381105":"柏垭镇","511381106":"飞凤镇","511381107":"思依镇","511381108":"文成镇","511381109":"二龙镇","511381110":"石滩镇","511381111":"老观镇","511381112":"龙泉镇","511381113":"千佛镇","511381114":"望垭镇","511381116":"妙高镇","511381117":"洪山镇","511381120":"水观镇","511381121":"金垭镇","511381122":"玉台镇","511381124":"木兰镇","511381127":"五马镇","511381128":"天宫镇","511381212":"桥楼乡","511381219":"博树回族乡","511381234":"峰占乡","511381235":"鹤峰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511381.json
// module id = 2479
// module chunks = 0